import { UseQueryResult, useQuery } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";
import { IContentBlockNode } from "../../sdk/types/api";

export const useGetBlocks = (
    queryKey: string | string[],
    productId: string,
    variantId: string,
    options?: { enabled?: boolean },
): UseQueryResult<IContentBlockNode[]> => {
    const auth = useAuth();

    return useQuery<IContentBlockNode[]>(
        queryKey,
        async () => {
            if (!auth.token) {
                throw new Error("Cannot fetch blocks without authorization token.");
            }

            return await api.Products.getBlocks(productId, variantId, auth.token);
        },
        options,
    );
};
